import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
/** New master-design controls (Components/PIM/common barrel also loads pim-tokens.css). */
import { NewSearch, NewSelectMultiSelect } from '../../../../Components/PIM/common';
import { MODULE_OPTIONS } from './bulk-edit.constants';
import { useBulkEditDispatch, useBulkEditState } from './BulkEditProvider';
import { DesignDetailsBulkGrid } from './DesignDetailsBulkGrid';
import { MODULE_REGISTRY } from './modules/registry';
import type { ModuleValue, SelectOption } from './types';
import './bulk-edit.css';

/**
 * Product Information → Bulk Edit page.
 * Header matches Figma "Nav Header 3" (node 6319-153251) built with the
 * master-design components/tokens: title + Select Module + Back. The flow targets
 * two modules — Measurements and Design Details.
 */
const BulkEdit: React.FC = () => {
  const { t: _t } = useTranslation('bulk-edit');
  /** TranslateFn declared globally in src/global.d.ts */
  const t = _t as unknown as TranslateFn;
  const history = useHistory();
  const state = useBulkEditState();
  const dispatch = useBulkEditDispatch();

  const moduleOptions: SelectOption<ModuleValue>[] = MODULE_OPTIONS.map((option) => ({
    value: option.value,
    label: t(option.labelKey),
  }));

  const isDesignDetailsModule = state.selectedModule?.value === 'design-details';

  const handleModuleChange = (option: unknown): void => {
    dispatch({ type: 'SET_MODULE', payload: option as SelectOption<ModuleValue> | null });
  };

  const handleDesignSearchChange = (value: string): void => {
    dispatch({ type: 'SET_DESIGN_SEARCH', payload: value });
  };

  const handleBack = (): void => {
    history.goBack();
  };

  const ActiveModule = state.selectedModule ? MODULE_REGISTRY[state.selectedModule.value] : null;

  return (
    <div className="bulk-edit-page">
      <div className="bulk-edit-header">
        <div className="bulk-edit-header__left">
          <h4 className="bulk-edit-header__title">{t('TITLE')}</h4>
          <div className="bulk-edit-header__controls">
            <div className="bulk-edit-header__select">
              <NewSelectMultiSelect
                options={moduleOptions}
                value={state.selectedModule}
                onChange={handleModuleChange}
                placeholder={t('SELECT_MODULE')}
                isSearchable={false}
              />
            </div>
          </div>
        </div>
        <div className="bulk-edit-header__right">
          {isDesignDetailsModule && (
            <NewSearch className="bombiix-search" value={state.designSearchText} onChange={handleDesignSearchChange} placeholder={t('SEARCH')} />
          )}
          <button type="button" className="btn bombiix-btn btn-light" onClick={handleBack}>
            {t('BACK')}
          </button>
        </div>
      </div>
      {isDesignDetailsModule && <DesignDetailsBulkGrid />}
      {ActiveModule && (
        <div className="bulk-edit-module">
          <ActiveModule productIds={state.selectedProductIds} />
        </div>
      )}
    </div>
  );
};

export default BulkEdit;
